var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "box" },
    [
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.dialogVisible,
            "close-on-click-modal": false,
            title: "编辑顶部信息",
            width: "950px",
            top: "5vh",
            "custom-class": "dialog_box",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
            close: _vm.onClose,
          },
        },
        [
          _c(
            "div",
            { staticClass: "from_box" },
            [
              _c(
                "el-form",
                {
                  ref: "ruleForm",
                  staticClass: "demo-ruleForm",
                  attrs: {
                    model: _vm.ruleForm,
                    rules: _vm.rules,
                    "label-width": "170px",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: "模块背景色:", prop: "backgroundColor" },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "justify-content": "space-between",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "默认填充色#524230" },
                            model: {
                              value: _vm.ruleForm.backgroundColor,
                              callback: function ($$v) {
                                _vm.$set(_vm.ruleForm, "backgroundColor", $$v)
                              },
                              expression: "ruleForm.backgroundColor",
                            },
                          }),
                          _vm._v(" "),
                          _c("el-color-picker", {
                            model: {
                              value: _vm.ruleForm.backgroundColor,
                              callback: function ($$v) {
                                _vm.$set(_vm.ruleForm, "backgroundColor", $$v)
                              },
                              expression: "ruleForm.backgroundColor",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "中文标题文字色:",
                        prop: "titleTextColor",
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "justify-content": "space-between",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "默认填充色#B4A593" },
                            model: {
                              value: _vm.ruleForm.titleTextColor,
                              callback: function ($$v) {
                                _vm.$set(_vm.ruleForm, "titleTextColor", $$v)
                              },
                              expression: "ruleForm.titleTextColor",
                            },
                          }),
                          _vm._v(" "),
                          _c("el-color-picker", {
                            model: {
                              value: _vm.ruleForm.titleTextColor,
                              callback: function ($$v) {
                                _vm.$set(_vm.ruleForm, "titleTextColor", $$v)
                              },
                              expression: "ruleForm.titleTextColor",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "数据展示文字色:",
                        prop: "dataShowTextColor",
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "justify-content": "space-between",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "默认填充色#FCF4E4" },
                            model: {
                              value: _vm.ruleForm.dataShowTextColor,
                              callback: function ($$v) {
                                _vm.$set(_vm.ruleForm, "dataShowTextColor", $$v)
                              },
                              expression: "ruleForm.dataShowTextColor",
                            },
                          }),
                          _vm._v(" "),
                          _c("el-color-picker", {
                            model: {
                              value: _vm.ruleForm.dataShowTextColor,
                              callback: function ($$v) {
                                _vm.$set(_vm.ruleForm, "dataShowTextColor", $$v)
                              },
                              expression: "ruleForm.dataShowTextColor",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "收益提现按钮背景色:",
                        prop: "withdrawBackgroundColor",
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "justify-content": "space-between",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "默认填充色#FAE8C2" },
                            model: {
                              value: _vm.ruleForm.withdrawBackgroundColor,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.ruleForm,
                                  "withdrawBackgroundColor",
                                  $$v
                                )
                              },
                              expression: "ruleForm.withdrawBackgroundColor",
                            },
                          }),
                          _vm._v(" "),
                          _c("el-color-picker", {
                            model: {
                              value: _vm.ruleForm.withdrawBackgroundColor,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.ruleForm,
                                  "withdrawBackgroundColor",
                                  $$v
                                )
                              },
                              expression: "ruleForm.withdrawBackgroundColor",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "收益提现按钮文字色:",
                        prop: "withdrawTextColor",
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "justify-content": "space-between",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "默认填充色#524230" },
                            model: {
                              value: _vm.ruleForm.withdrawTextColor,
                              callback: function ($$v) {
                                _vm.$set(_vm.ruleForm, "withdrawTextColor", $$v)
                              },
                              expression: "ruleForm.withdrawTextColor",
                            },
                          }),
                          _vm._v(" "),
                          _c("el-color-picker", {
                            model: {
                              value: _vm.ruleForm.withdrawTextColor,
                              callback: function ($$v) {
                                _vm.$set(_vm.ruleForm, "withdrawTextColor", $$v)
                              },
                              expression: "ruleForm.withdrawTextColor",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "备注文案:", prop: "remark" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "" },
                        model: {
                          value: _vm.ruleForm.remark,
                          callback: function ($$v) {
                            _vm.$set(_vm.ruleForm, "remark", $$v)
                          },
                          expression: "ruleForm.remark",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "备注文案文字色:",
                        prop: "remarkTextColor",
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "justify-content": "space-between",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "默认填充色#FCF4E4" },
                            model: {
                              value: _vm.ruleForm.remarkTextColor,
                              callback: function ($$v) {
                                _vm.$set(_vm.ruleForm, "remarkTextColor", $$v)
                              },
                              expression: "ruleForm.remarkTextColor",
                            },
                          }),
                          _vm._v(" "),
                          _c("el-color-picker", {
                            model: {
                              value: _vm.ruleForm.remarkTextColor,
                              callback: function ($$v) {
                                _vm.$set(_vm.ruleForm, "remarkTextColor", $$v)
                              },
                              expression: "ruleForm.remarkTextColor",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _vm.componentSubcode === "dD_2"
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "备注文案背景色:",
                            prop: "remarkBackgroundColor",
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "justify-content": "space-between",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: { placeholder: "默认填充色#685139" },
                                model: {
                                  value: _vm.ruleForm.remarkBackgroundColor,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.ruleForm,
                                      "remarkBackgroundColor",
                                      $$v
                                    )
                                  },
                                  expression: "ruleForm.remarkBackgroundColor",
                                },
                              }),
                              _vm._v(" "),
                              _c("el-color-picker", {
                                model: {
                                  value: _vm.ruleForm.remarkBackgroundColor,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.ruleForm,
                                      "remarkBackgroundColor",
                                      $$v
                                    )
                                  },
                                  expression: "ruleForm.remarkBackgroundColor",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: "解释说明弹窗文案：", prop: "popUpText" },
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          placeholder: "请输入",
                          autosize: "",
                          type: "textarea",
                        },
                        model: {
                          value: _vm.ruleForm.popUpText,
                          callback: function ($$v) {
                            _vm.$set(_vm.ruleForm, "popUpText", $$v)
                          },
                          expression: "ruleForm.popUpText",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: "升级中心入口：", prop: "levelUpEntry" },
                    },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.ruleForm.levelUpEntry,
                            callback: function ($$v) {
                              _vm.$set(_vm.ruleForm, "levelUpEntry", $$v)
                            },
                            expression: "ruleForm.levelUpEntry",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: 1 } }, [
                            _vm._v("打开"),
                          ]),
                          _vm._v(" "),
                          _c("el-radio", { attrs: { label: 0 } }, [
                            _vm._v("关闭"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.ruleForm.levelUpEntry === 1
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "升级入口展示图:",
                            prop: "levelUpPic",
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                width: "130px",
                                height: "130px",
                                background: "#f9f9f9",
                                "border-radius": "4px",
                                border: "1px solid #eeeeee",
                                position: "relative",
                              },
                            },
                            [
                              _c(
                                "el-upload",
                                {
                                  staticClass: "avatar-uploader",
                                  attrs: {
                                    "show-file-list": false,
                                    action: "",
                                    "http-request": _vm.handleFileUpload,
                                  },
                                },
                                [
                                  _vm.ruleForm.levelUpPic &&
                                  _vm.ruleForm.levelUpPic != null
                                    ? _c("el-image", {
                                        staticStyle: {
                                          width: "130px",
                                          height: "130px",
                                        },
                                        attrs: {
                                          src: _vm.ruleForm.levelUpPic,
                                          fit: "contain",
                                        },
                                      })
                                    : _c(
                                        "div",
                                        [
                                          _c("el-image", {
                                            staticStyle: {
                                              width: "130px",
                                              height: "130px",
                                            },
                                            attrs: {
                                              src: require("@/assets/" +
                                                (_vm.componentSubcode === "dD_2"
                                                  ? "sj2"
                                                  : "sj1") +
                                                ".png"),
                                              fit: "contain",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                  _vm._v(" "),
                                  _vm.ruleForm.levelUpPic
                                    ? _c("i", {
                                        staticClass: "el-icon-error",
                                        staticStyle: {
                                          position: "absolute",
                                          right: "-30px",
                                          top: "-10px",
                                          "font-size": "25px",
                                        },
                                        on: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                            return _vm.delPic($event)
                                          },
                                        },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              staticStyle: {
                                color: "#969696",
                                "font-size": "12px",
                              },
                            },
                            [
                              _vm._v(
                                "图片尺寸" +
                                  _vm._s(
                                    _vm.componentSubcode === "dD_2"
                                      ? "577*86"
                                      : "654*91"
                                  ) +
                                  "，png格式（可参考示例图样）"
                              ),
                            ]
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.ruleForm.levelUpEntry === 1
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "升级入口展示等级：",
                            prop: "showLevel",
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: "请选择",
                                clearable: "",
                                filterable: "",
                              },
                              model: {
                                value: _vm.ruleForm.showLevel,
                                callback: function ($$v) {
                                  _vm.$set(_vm.ruleForm, "showLevel", $$v)
                                },
                                expression: "ruleForm.showLevel",
                              },
                            },
                            _vm._l(_vm.options, function (item) {
                              return _c("el-option", {
                                key: item.grade,
                                attrs: { label: item.name, value: item.grade },
                              })
                            }),
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              staticStyle: {
                                color: "#969696",
                                "font-size": "12px",
                              },
                            },
                            [
                              _vm._v(
                                " 选择特定等级后，低于当前等级的用户会向其展示升级入口，高于或等于当前等级的会隐藏升级入口"
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.submitForm("ruleForm")
                            },
                          },
                        },
                        [_vm._v("确认")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.resetForm("ruleForm")
                            },
                          },
                        },
                        [_vm._v("重置")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }